// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-menu[data-v-997572da]{background-color:#fff;border-radius:7px;box-shadow:0 3px 20px rgba(0,0,0,.15);overflow:hidden}", ""]);
// Exports
module.exports = exports;
